(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4070],{

/***/ 19605:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiratie/[slug]",
      function () {
        return __webpack_require__(84303);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_util_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61692);
/* harmony import */ var _modules_skeletons_components_skeleton_product_preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _modules_common_render_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41702);





var SkeletonCollectionPage = function(param) {
    var content = param.content;
    var items = content === null || content === void 0 ? void 0 : content.content;
    /*const [firstItem, setFirstItem] = useState<
        HeroProp | OneImageProp | TwoImageProp | FullTextProp
    >()
    const [items, setItems] =
        useState<Array<HeroProp | OneImageProp | TwoImageProp | FullTextProp>>()*/ /*useEffect(() => {
        const items = content?.content
        setFirstItem(items?.shift())
        setItems(items)
    }, [content])*/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "grain-background",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 grid grid-cols-1 small:grid-cols-6  px-4 py-7 lg:px-12 lg:py-20",
                children: [
                    items && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_render_item__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: items[0]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative block col-span-4 small:col-span-1 h-20 bg-gray-100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-5 small:px-8 transition flex flex-col small:items-start py-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "small:content-container ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: "grid grid-cols-2 small:grid-cols-3 medium:grid-cols-4 gap-x-4 gap-y-8",
                                children: (0,_lib_util_repeat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(8).map(function(index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_skeletons_components_skeleton_product_preview__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative z-10 grid grid-cols-1 small:grid-cols-6 px-4 small:px-0 py-7",
                children: items && items.map(function(item, index) {
                    return index === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_render_item__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: item
                    });
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-0 pointer-events-none",
                style: {
                    background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                },
                children: "\xa0"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonCollectionPage);


/***/ }),

/***/ 84303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57469);
/* harmony import */ var _modules_common_components_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63269);
/* harmony import */ var _modules_layout_templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77092);
/* harmony import */ var _modules_skeletons_templates_skeleton_collection_page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31660);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _modules_common_render_item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41702);








var InspirationPage = function(param) {
    var notFound = param.notFound, post = param.post;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var replace = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().replace;
    if (notFound) {
        if (_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .IS_BROWSER */ .Q) {
            replace("/404");
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_skeletons_templates_skeleton_collection_page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
    }
    var ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_components_head__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: (ref6 = (ref = post.seo) === null || ref === void 0 ? void 0 : ref.metaTitle) !== null && ref6 !== void 0 ? ref6 : post === null || post === void 0 ? void 0 : post.title,
                description: (ref1 = post.seo) === null || ref1 === void 0 ? void 0 : ref1.metaDescription,
                canonical: (ref2 = post.seo) === null || ref2 === void 0 ? void 0 : ref2.canonicalURL,
                robots: (ref3 = post.seo) === null || ref3 === void 0 ? void 0 : ref3.metaRobots,
                image: (ref7 = (ref4 = post.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.metaImage) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref7 !== void 0 ? ref7 : null
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grain-background",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative z-10 grid grid-cols-6 px-4 py-7 lg:px-12 lg:py-20",
                        children: (post === null || post === void 0 ? void 0 : post.content) && (post === null || post === void 0 ? void 0 : post.content.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_render_item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                item: item
                            });
                        }))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 z-0 pointer-events-none",
                        style: {
                            background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                        },
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
InspirationPage.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_layout_templates__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (InspirationPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9128,3662,3415,1228,5445,5937,4617,6158,6556,3815,6659,2931,7092,1702,9774,2888,179], function() { return __webpack_exec__(19605); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);